'use strict';

export const ANIMATION_NAME_PREFIX = 'REA-CSS-';
//# sourceMappingURL=misc.js.map